// Trusted By Brands Section Data
export const TRUSTED_BRANDS_LOGOS = [
  {
    src: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/57600b18-d5a0-4a75-8236-6206177c7d65.png',
    alt: 'swiggy',
  },
  {
    src: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/fa492bf5-f2e8-4c4f-b6f7-7bbb851befdb.png',
    alt: 'myntra',
  },
  {
    src: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/71dc20fb-7e0b-4b00-9ceb-aa25529f7d06.png',
    alt: 'zomato',
  },
  {
    src: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/34785df4-9e20-4b3f-a637-c2d9b3746a2f.png',
    alt: 'flipkart',
  },
  {
    src: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/3b8d16b4-e258-45a5-9933-b603b594e78f.png',
    alt: 'appolo',
  },
  {
    src: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/2204cf87-0c36-49b0-b2d6-0309d3d14afd.png',
    alt: 'bosch',
  },
];
